import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

import useDateOptions from "@/features/FilterTable/useDateOptions";

const filterA7FIAInstrumentTSSchema = z.object({
  date_equals: z.string().optional(),
  underlying_id_equals: z.string().optional(),
  denomination_du_sous_jacent: z.string().optional(),
});

export type FilterA7FIAInstrumentTSSchema = z.infer<
  typeof filterA7FIAInstrumentTSSchema
>;

const initialFields: Field[] = [
  {
    name: "date_equals",
    label: `Date`,
    type: "autocomplete",
    options: [],
  },
  {
    name: "underlying_id_equals",
    label: `Instrument financier`,
    type: "input",
  },
  {
    name: "denomination_du_sous_jacent",
    label: `Émetteur`,
    type: "input",
  },
];

export function FilterA7FIAInstrumentTS({
  table_name,
  client,
}: {
  client: string;
  table_name: string;
}) {
  const { fields } = useDateOptions(client, table_name, initialFields);

  return (
    <FilterTable
      schema={filterA7FIAInstrumentTSSchema}
      client={client}
      tableName="a7_fia_underlying_ts"
      fields={fields}
      customBuildPath={() => `a7-fia/${table_name}`}
      excludeFieldsFromConvertDate={["date_equals"]}
    />
  );
}
